function calculateDecreaseByPercent(bids, value) {
  const percentage = value / 100;

  return bids.map(bid => {
    const newPriceOffer = bid.priceOffer - percentage * bid.priceOffer;
    return {
      ...bid,
      priceOffer: newPriceOffer,
    };
  });
}

function calculateDecreaseByValue(bids, value) {
  return bids.map(bid => {
    const newPriceOffer = bid.priceOffer - value;
    return {
      ...bid,
      priceOffer: newPriceOffer,
    };
  });
}

function calculateIncreaseByValue(bids, value) {
  return bids.map(bid => ({
    ...bid,
    priceOffer: bid.priceOffer + value,
  }));
}

function calculateIncreaseByPercent(bids, value) {
  const percentage = value / 100;
  return bids.map(bid => ({
    ...bid,
    priceOffer: bid.priceOffer + percentage * bid.priceOffer,
  }));
}

function calculateAbsolute(bids, value) {
  return bids.map(bid => {
    return {
      ...bid,
      priceOffer: value,
    };
  });
}

function handleIncreaseCalculation({ bids, value, valueType }) {
  if (valueType === 'percent') {
    return calculateIncreaseByPercent(bids, value);
  } else if (valueType === 'amount') {
    return calculateIncreaseByValue(bids, value);
  }
}

function handleDecreaseCalculation({ bids, value, valueType }) {
  if (valueType === 'percent') {
    return calculateDecreaseByPercent(bids, value);
  } else if (valueType === 'amount') {
    return calculateDecreaseByValue(bids, value);
  }
}

export default function calculateBidPriceOffer({
  bids,
  type,
  valueType,
  value,
}) {
  if (type === 'absolute') {
    return calculateAbsolute(bids, value);
  } else if (type === 'increase') {
    return handleIncreaseCalculation({ bids, value, valueType });
  } else if (type === 'decrease') {
    return handleDecreaseCalculation({ bids, value, valueType });
  }
}
